import { Carousel } from "react-bootstrap"
import Image1 from "../images/informes.jpg";
import Image2 from "../images/capacitacion.jpg";
import Image3 from "../images/image3.jpg";
import { Link } from "react-router-dom";
import WhatsAppButton from "../../../componet/WhatsAppButton";
import { useState } from "react";

export const Navbar = () => {
    const [open, setOpen] = useState(false);
    return (
        <>
            <div id="navbar" className="background_index">
                {/* <Snowfall color="white" snowflakeCount={200} />
        <Snowfall
          snowflakeCount={200}
          color="#ff0000"   // rojo
        />
        <Snowfall
          snowflakeCount={200}
          color="#00ff00"   // verde
        /> */}
                <Carousel
                    className="carousel"
                    interval={3000}
                    controls={true}
                    indicators={false}
                >
                    <Carousel.Item>
                        <img
                            src={Image1}
                            alt="foto de todo el team"
                            className="full-background-image"
                        />
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                            src={Image2}
                            alt="foto de todo el team"
                            className="full-background-image"
                        />
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                            src={Image3}
                            alt="foto de todo el team"
                            className="full-background-image"
                        />
                    </Carousel.Item>
                </Carousel>

                <div className="navbar_index fw-bold">
                    <div className="display-flex align-items-center">
                        <button
                            className="menu-toggle"
                            onClick={() => setOpen(!open)}
                        >
                            ☰
                        </button>

                        <div className={`nav-links ${open ? "open" : ""}`}>
                            <a href="/">Inicio</a>
                            <Link to="/Conocenos">Conócenos</Link>
                            <a href="#servicios">Servicios</a>
                            <a href="#footer">Contacto</a>
                            <a href="#noticias">Noticias</a>
                            <a href="#herramientas">Herramientas</a>
                            <a href="/political">Política</a>
                            <Link to="/login" className="login-button">
                                Iniciar sesión
                            </Link>
                        </div>
                    </div>

                    <div className="social-icons">
                        <a href="tel:+5731644483635">
                            <i className="fa fa-phone"></i>
                        </a>
                        <a href="https://www.facebook.com/SISTEMAROCKYSAS">
                            <i className="fa-brands fa-facebook"></i>
                        </a>
                        <a href="https://www.instagram.com/rockysas2023/">
                            <i className="fa-brands fa-instagram"></i>
                        </a>
                    </div>
                </div>
                <div className="logo-container">
                    <h1 className="logo">Rocky</h1>
                    <p className="subtitle">
                        Sistema de información en atención primaria S.A.S
                    </p>
                </div>
                < WhatsAppButton />
            </div>

        </>

    )

}